/**
 * @ngdoc           directive
 * @name            redirectPostUrl
 *
 * @description     Redirect a post button g:actionSubmit
 *                  Simulate how g:actionSubmit used to work by redirecting form based upon action attribute
 *                  See http://docs.grails.org/3.1.1/ref/Tags/actionSubmit.html
 *
 * @usage           <button redirect-post-url="<g:createLink controller='candidateSubmission' action='update' />">Save</button>
 *                  Tip: Also try adding <form ng-submit="formName.$valid" /> to prevent the form form submit until form is valid
 */
(function() {
    var redirectPostUrl = function(){
        return {
            restrict: "A",
            replace: false,
            transclude: false,
            require: '^form', // parent form binding
            link: function (scope, element, attrs, formCtrl) {
                // console.log('redirectPostUrl','link()',formCtrl);
                var formElement = angular.element(element).closest('form');
                // console.log('redirectPostUrl','formElement.attr("action")',formElement.attr("action"));
                element.bind("click", function (event) {
                    // console.log('redirectPostUrl','click');
                    event.stopPropagation();
                    event.preventDefault();
                    // console.log('redirectPostUrl','attrs.redirectPostUrl',attrs.redirectPostUrl);
                    formElement.attr("action", attrs.redirectPostUrl).submit();
                });
            }
        }
    };
    redirectPostUrl.$inject = [];
    angular.module('app').directive('redirectPostUrl', redirectPostUrl);
}());
